export function HomeIndicator() {
  return (
    <div className="fixed bottom-0 left-0 right-0 h-[34px] flex justify-center items-end pb-2 safe-bottom z-50 pointer-events-none">
      <div className="w-[134px] h-[5px] bg-gray-900 rounded-[10px]" />
    </div>
  )
} 